import { IPortalInvoiceResponse } from "shared";

import { PaymentPlanStrip } from "../../../common/Components/PaymentPlan/PaymentPlanStrip";

interface InvoicePaymentPlanProps {
  invoiceData: IPortalInvoiceResponse;
  showPaymentButton: boolean;
  onPayNextInstalment: () => void;
}

export function InvoicePaymentPlan({
  invoiceData,
  showPaymentButton,
  onPayNextInstalment,
}: InvoicePaymentPlanProps) {
  if (!invoiceData.invoice?.currentPaymentPlan) {
    return null;
  }

  return (
    <PaymentPlanStrip
      plan={ invoiceData.invoice.currentPaymentPlan }
      currency={ invoiceData.invoice.xero_currency }
      timezone={ invoiceData.invoice.organisationTimezone }
      actions={ showPaymentButton ? (
        <button
          type={ `button` }
          onClick={ onPayNextInstalment }
          className={ `h-7 cursor-pointer whitespace-nowrap rounded-md bg-paidniceGreen-600 px-2.5 text-xs font-medium text-white hover:bg-paidniceGreen-700 disabled:opacity-50` }
        >
          { `Pay next installment` }
        </button>
      ) : null }
    />
  );
}
